<template>
  <form>
    <div>
      <ol class="pl-0">
        <draggable 
          v-if    = "audioPaths.length"
          v-model = "audioPaths"
        >

          <li
            v-for   = "(audioPath, index) in audioPaths"
            :key    = "index"
            class   = "pl-4 pr-2 py-1 mb-2 audio-path"
          >

            <div class="path">
              <v-tooltip 
                bottom 
                open-delay  = "500"
              > 
                <template v-slot:activator="{ on, attrs }"> 
                  <span 
                    v-on    = "on" 
                    v-bind  = "attrs"
                  >
                    {{ audioPath }}
                  </span>
                </template>

                {{ audioPath }}
              </v-tooltip>
            </div>
            <v-btn
              icon
              small
              @click    = "onCloseChip(index);"
            >
              <v-icon small>mdi-close</v-icon>
            </v-btn>

          </li>

        </draggable>
      </ol>
    </div>
    <div v-if="!audioPaths.length">There are no audio paths added</div>
    <div class="mt-2">
      <v-text-field
        v-model="newAudioPath"
        append-icon="mdi-plus-circle"
        label="Add audio path"
        @click:append="addAudioPath"
      ></v-text-field>
    </div>
  </form>
</template>

<script>
import { SET_AUDIO_PATHS_CONFIG } from '@/utils/mutation-types';

export default {
  name: 'AudioPathsForm',
  data: function () {
    return {
      newAudioPath: '',
    };
  },
  computed: {
    audioPaths: {
      get: function () {
        return this.$store.state.audioPathsConfig;
      },
      set: function (value) {
        this.$store.commit(SET_AUDIO_PATHS_CONFIG, value);
      },
    },
  },
  methods: {
    onCloseChip(index) {
      let audioPathCopy = Array.from(this.audioPaths);
      audioPathCopy.splice(index, 1);
      this.$store.commit(SET_AUDIO_PATHS_CONFIG, audioPathCopy);
    },
    addAudioPath() {
      if (!this.newAudioPath)
        return;
      let audioPathCopy = Array.from(this.audioPaths);
      audioPathCopy.push(this.newAudioPath);
      this.newAudioPath = '';
      this.$store.commit(SET_AUDIO_PATHS_CONFIG, audioPathCopy);
    },
  },
};
</script>

<style scoped lang="scss">

@import '../../../styles/colors.scss';

.audio-path {
  cursor:         pointer;
  display:        flex;
  flex-direction: row;
  align-items:    center;

  list-style-type:    none;
  background-color:   $darker-label-color;
  border-radius:      99px;

  .path {
    flex:           1;

    color:          white;

    text-overflow:  ellipsis;
    overflow:       hidden;
    white-space:    nowrap;
  }
}
</style>
